<template>
  <div style="background: #f0f2f2">
    <div class="nav">
      <v-head></v-head>
    </div>
    <v-route :bindData="bindData"></v-route>
    <div
      class="container"
      style="background: white;
        box-shadow: 3px 3px 6px 0px rgba(0, 0, 0, 0.14);
        border-radius: 4px;
        padding: 0 10px;
        overflow: hidden;">
      <v-breadcrumb
        value1="首页"
        :value2="value4"
        :value3="value2"
        :value4="value3"
        :url="url"
      ></v-breadcrumb>
      <div class="container_box mt20 mb20">
        <div class="container_box_left">
          <h2>{{ data.title }}</h2>
          <div class="time">
            <div>时间:{{ data.time }} 阅读:{{ data.viewCount }}</div>
            <div class="rightIcon">
              <div class="thumb">
                <img
                  src="../../assets/img/点赞.png"
                  alt=""
                  v-if="isThumbs"
                  @click="beThumb"
                />
                <img
                  src="../../assets/img/已点赞.png"
                  alt=""
                  v-if="isThumbs1"
                    @click="beThumb"
                />
                <span>({{ ThumbNum }})</span>
              </div>
              <div class="collect">
                <img
                  src="../../assets/img/收藏.png"
                  alt=""
                  v-if="isCollect"
                  @click="beCollect"
                />
                <img
                  src="../../assets/img/已收藏.png"
                  alt=""
                  v-if="isCollect1"
                  @click="beCollect"
                />
                <span>({{ CollectNum }})</span>
              </div>
            </div>
          </div>
          <v-aplayer
            v-if="data.href && type == 'mp3'"
            style="margin: 20px 0"
            autoplay
            :music="music"
          ></v-aplayer>
          <div class="content" v-html="data.content"></div>         
        </div>
        <div class="container_box_right">
          <h3 style="margin-top: 84px">更多动态</h3>
          <div class="over-box">
            <div class="three_item" v-for="i in datalist">
              <img  :src="i.coverImageUrl"  style="cursor:default"/>
              <div>
                <h4 class="hover" @click="goTo(i.path)">{{ i.title }}</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <v-footer></v-footer>
  </div>
</template>

<script>
    import Aplayer from 'vue-aplayer'
    import route from '../../components/common/route1'
    export default {
        name: "list1",
        data(){
            return{
                data:{
                    title:null
                },
                value2:null,
                value3:null,
                value4:null,
                url:null,
                bindData:null,
                datalist:null,
                ljcode:null,
                rootColumnId:null,
                columnId:null,
                articleId:null,
                isThumbs:true,
                isCollect:true,
                isThumbs1:false,
                isCollect1:false,
                ThumbNum:0,
                CollectNum:0,
                id:null,
                zan:false,
                sc:false,
                userId:''
            }
        },
        created() {
           this.initBindData();
           this.getDetail();        
        },
        watch:{
            $route:function (newValue) {
                let that = this;

                let ljcode = newValue.query.ljcode;
                let articleId = newValue.query.articleId;
                let rootColumnId = newValue.query.rootColumnId;
                let columnId = newValue.query.columnId;
                this.value2 = this.common.getValue2(ljcode);

                this.url = [ljcode,rootColumnId,columnId]
                let url = `${api}/api/cms/article/detail?articleId=${articleId}`;
                this.common.axios.get(url).then(v=>{
                 
                    that.data = v.data.data;
                    that.data.content = that.data.content.replace(/\s+/g," ");
                    that.data.time = this.common.date2Local(that.data.createDate)
                  
                    if(that.data.href && that.data.href.endsWith("mp3")){
                        that.type = "mp3";
                        that.music={
                            title: that.data.title,
                            author: '广东国地规划科技股份有限公司',
                            url: that.data.href,
                            pic: apiimg+that.data.coverImageUrl,
                            lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
                        };
                    }
                });
                this.initBindData();    
                this.getDetail()           
            }
        },
        methods:{
            initBindData(){
                switch (this.$route.query.rootColumnId) {
                
                    case '40288a9d6e91c70a016e91c895ae0001':
                        console.log(this.$route.query.rootColumnId,"root")
                        this.bindData=[
                            {
                                name:'720°全景游览',
                                url:'#/vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=40288a9d6e91c70a016e91c895ae0001',
                                // cid:'40288a9d6e91c70a016e91cc6eb5000a'
                            },
                            {
                                name:'漫游讲解',
                                url:'#/myjj?ljcode=myjj&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=2c9a4c9b6ea63d8c016ea6474f040002',
                                cid:'2c9a4c9b6ea63d8c016ea6474f040002'
                            },
                            {
                                name:'场景切换',
                                url:'#/cjqh?ljcode=cjqh&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=cjqh',
                                cid:'cjqh'
                            }
                        ];
                        break;
                 
                }
      
            },
            getIsShow(){
                let url = `${api}/api/cms/article/detail?articleId=${articleId}&userId=${this.userId}`;
                this.common.axios.get(url).then(v=>{
                    that.CollectNum=v.data.data.scCount;
                    that.ThumbNum = v.data.data.zanCount;

                })},
            getDetail(){
                let that = this;
                let ljcode = this.ljcode = this.$route.query.ljcode;
                let articleId = this.articleId = this.$route.query.articleId;
                let rootColumnId = this.rootColumnId = this.$route.query.rootColumnId;
                let columnId = this.columnId = this.$route.query.columnId;
                this.value2  = this.common.getValue2(ljcode);
                this.url = [ljcode,rootColumnId,columnId]
                this.userId = localStorage.getItem('id')
            
                let url = `${api}/api/cms/article/detail?articleId=${articleId}&userId=${this.userId}`;
                this.common.axios.get(url).then(v=>{
                    that.data = v.data.data;
                    that.data.content = that.data.content.replace(/\s+/g," ");
                    that.data.time = this.common.date2Local(that.data.createDate)
                    that.value3 = that.data.title;
                    that.id=v.data.data.id;
                    that.CollectNum=v.data.data.scCount;
                    that.ThumbNum = v.data.data.zanCount;
                    that.zan=v.data.data.zan
                    that.sc=v.data.data.sc  
                    that.value4=that.data.rootColumnInfo.name
                    if(that.data.href && that.data.href.endsWith("mp3")){
                        that.type = "mp3";
                        that.music={
                            title: that.data.title,
                            author: '广东国地规划科技股份有限公司',
                            url: that.data.href,
                            pic: apiimg+that.data.coverImageUrl,
                            lrc: '[00:00.00]lrc here\n[00:01.00]aplayer'
                        };
                    };
                  if(this.userId==null){
                    this.isCollect=true;
                    this.isThumbs=true;
                  }else if(this.userId!=null){
                     if(that.zan==true){
                       this.isThumbs=false;
                       this.isThumbs1=true;
                     }else if(that.zan==false){
                       this.isThumbs1=false;
                       this.isThumbs=true;
                     };
                     if(that.sc==true){
                         this.isCollect=false;
                       this.isCollect1=true;
                     }else if(that.sc==false){
                       this.isCollect=true;
                       this.isCollect1=false;
                     }
                  }
                });
                let url1 = `${api}/api/cms/article/list?rootColumnId=${rootColumnId}&columnId=${columnId}&type=&pageSize=20&currentPage=1`;
                this.common.axios.get(url1).then(v=>{
                    let data = v.data.data.list;
                    data.forEach(v=>{
                        v.coverImageUrl = apiimg+v.coverImageUrl;
                        v.path = `rootColumnId=${rootColumnId}&columnId=${columnId}&articleId=${v.id}`
                    });
                    this.datalist = data;
                });
                                     
            },
            beThumb(){
               if(this.userId!=null){  
                let url2 = `${api}/api/cms/article/addZan?articleId=${this.$route.query.articleId}&userId=${this.userId}`
                this.common.axios.get(url2).then((res)=>{
                    console.log(res)
                    if(res.data.msg='点赞成功'){
                        this.isThumbs=!this.isThumbs
                        this.isThumbs1=!this.isThumbs1
                        this.ThumbNum =this.ThumbNum+1
                         if(this.isThumbs==true){
                       this.$message.error('取消点赞')
                         this.ThumbNum =this.ThumbNum-2
                   }else if(this.isThumbs1==true){
                       this.$message.success('点赞成功')
                   }      
                    }
                }).catch((err)=>{
                    console.log(err)
                })
                }else if(this.userId==null){
                    this.$message.error('请登录后点赞')
                    return;
                }
            },
            beCollect(){
                if(this.userId!=null){         
                let url3=`${api}/api/cms/article/addCollect?articleId=${this.$route.query.articleId}&userId=${this.userId}`     
                this.common.axios.post(url3).then((res)=>{
                    console.log(res)
                   this.isCollect=!this.isCollect
                   this.isCollect1=!this.isCollect1          
                    if(this.isCollect==true){
                       this.$message.error('取消收藏')
                          this.CollectNum = this.CollectNum - 1
                         console.log(typeof(this.CollectNum))
                   }else if(this.isCollect1==true){
                       this.$message.success('收藏成功')
                       this.CollectNum = this.CollectNum + 1
                   }      
                }).catch((err)=>{console.log(err)})
                }else if(this.userId==null){
                    this.$message.error('请登录后收藏')
                    console.log(this.$route.query.articleId,123)
                }
            },
            goTo(v){
                this.$router.push({path:`/detail2?ljcode=${this.ljcode}&${v}`})
            },     
        },
        components:{
            "v-route":route,
            "v-aplayer":Aplayer
        }
    }
</script>

<style lang="less" scoped>
.nav {
  height: 350px;
  background: url("../../assets/img/headerbanner.jpg");
}
.container_box {
  display: flex;
  &_left {
    width: 700px;
    margin-right: 100px;
    h2 {
      font-size: 24px;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      text-align: left;
      margin-bottom: 10px;
    }
    .time {
      height: 24px;
      font-size: 12px;
      margin-top: 12px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 36px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      > .rightIcon {
        display: flex;
        width: 15%;
        justify-content: space-between;
        align-items: center;
        > .thumb {
          display: flex;
          align-items: center;
          > img {
            width: 18px;
            margin-right: 6px;
            cursor: pointer;
          }
          > span {
            margin-right: 12px;
          }
        }
        > .collect {
          display: flex;
          align-items: center;
          > img {
            width: 18px;
            margin-right: 6px;
            cursor: pointer;
          }
          > span {
            margin-right: 12px;
          }
        }
      }
    }
  }
  &_right {
    flex: 1;
    .over-box {
      max-height: 800px;
      overflow: auto;
    }
    .over-box::-webkit-scrollbar {
      /*滚动条整体样式*/

      width: 10px; /*高宽分别对应横竖滚动条的尺寸*/

      height: 1px;
    }

    .over-box::-webkit-scrollbar-thumb {
      /*滚动条里面小方块*/

      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: #edb98c;
    }

    .over-box::-webkit-scrollbar-track {
      /*滚动条里面轨道*/

      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 10px;
      background: #f7eadf;
    }
    .three_item {
      margin-top: 30px;
      height: 104px;
      display: flex;
      img {
        width: 150px;
        height: 100px;
        margin-right: 15px;
      }
      div {
        flex: 1;
        text-align: left;
        h4 {
          width: 200px;
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 22px;
          display: inline-block;
        }
        span {
          display: inline-block;
          margin-top: 20px;
          height: 22px;
          font-size: 16px;
          font-weight: 400;
          color: rgba(253, 170, 24, 1);
          line-height: 22px;
        }
      }
    }
  }

  text-align: justify;
}
</style>
<style lang="less">
.content {
  p {
    text-indent: 0em !important;
    line-height: 32px !important;
    font-size: 14px !important;
    color: #666666 !important;
    // margin-bottom: 50px !important;
    span {
      font-size: 14px !important;
      color: #666666 ;
      strong {
        font-size: 26px !important;
      }
    }
  }
  img {
    max-width: 100% !important;
  }
  table,
  table tr th,
  table tr td {
    border: 1px solid black;
    vertical-align: middle;
  }
  table{
    tr{
      td{
        // line-height: 97px;
      }
    }
  }
}
</style>
